export enum ProductDataStateValues {
  ERROR = -1,
  IDLE = 0,
  PROCESSING = 1,
  REVIEWREQUIRED = 2,
  READYFOREXPORT = 3,
  EXPORTING = 4,
  READYFORCOPYING = 5,
}

export interface ProductDataState {
  state: ProductDataStateValues;
  comment: string;
  updatedBy?: string;
  updatedAt?: string;
}

export interface ProductDataStateForUpdate {
  state: ProductDataStateValues;
  comment?: string;
}
